module.exports = "https://coursera_assets.s3.amazonaws.com/images/fed7f16b8aff2b3e53c1e0a2a37a4fb2.png";